<template>
    <div :class="[ 'qw-message', { 'reply': reply } ]">
        <p class="sender">{{ sender }}</p>
        <div class="qw-content">
            <slot></slot>
        </div>
        <p class="date" v-if="date">{{ date | humanize }}</p>
    </div>
</template>

<script>
export default {
    name: "qw-message",
    props: {
        reply: {
            required: false,
            type: Boolean,
            default: true
        },
        sender: {
            required: false,
            type: String
        }
    },
    computed: {
        date() {
            return +new Date;
        }
    }
}
</script>

<style lang="scss" scoped>
.qw-message {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex-direction: column;
    margin: 0px 0px 10px 0px;
    background-color: transparent;
    .sender {
        margin: 0px 0px 2px 0px;
        font-size: 12px;
        font-family: $lato;
        color: $dark-gray;
        text-align: right;
    }
    .qw-content {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        margin: 0px 0px 5px 0px;
        max-width: 95%;
    }
    .date {
        margin: 0;
        font-size: 11px;
        font-family: $lato;
        font-weight: normal;
        color: darken($gray, 3%);
    }
    &.reply {
        align-items: flex-start;
    }
    &:last-child {
        margin: 0;
    }
}
</style>